import { collection, addDoc } from 'firebase/firestore';
import { orderDb } from './firebaseOrders';

export const saveOrderToFirebase = async (
  orderNumber,
  confirmationNumber,
  myArr,
  customerDetails,
  address,
  shippingRate,
  custEmail,
  Status
) => {
  try {
    const formattedItems = myArr.map((arr) => ({
      id: arr[0],
      color: arr[1],
      price: arr[2],
      quantity: arr[3],
      size: arr[4],
      style: arr[5],
      thumId: arr[6],
      rating: arr[7],
      weight: arr[8],
      // color$API: arr[9],
      garmentPrice:arr[9],
      imagePrice:arr[10],
      thumImage: arr[11],
      SalePrice:arr[12],
      // image_width: arr[14],
      //  image_height: arr[15], 
      //  image_width2: arr[16],
        // image_height2: arr[17],
        finalUrl: arr[13],
        url: arr[14]

// inja badan 14 ezafe kon baraye imageSize
    }));
    // console.log(formattedItems)
    await addDoc(collection(orderDb, 'orders'), {
      orderNumber,
      confirmationNumber,
      shippingRate,
      custEmail,
      Status,
      items: formattedItems,
      customerDetails: {
        name: customerDetails.name,
        email: customerDetails.email,
        phone: customerDetails.phone,
      },
      shippingAddress: {
        name: address.name,
        street1: address.street1,
        street2: address.street2 || '',
        city: address.city,
        zip: address.zip,
        state: address.state,
        country: address.country,
      },
      billingAddress: {
        street1: customerDetails.address.line1,
        street2: customerDetails.address.line2 || '',
        city: customerDetails.address.city,
        zip: customerDetails.address.postal_code,
        state: customerDetails.address.state,
        country: customerDetails.address.country,
      },
      createdAt: new Date(),
    });

    console.log('✅ Order saved to Firebase',Status);
  } catch (error) {
    console.error('❌ Error saving order to Firebase:', error);
  }
};
